module.exports = __webpack_public_path__ + "media/images/landing__teaser__scoring-3bf8312cdbd1bdabd5f8005d8a3729b1.png";